import React, { useEffect, useState } from 'react';
import './Profile.css';
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faEnvelope, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../url';
import ShareWeb from '../ShareWeb/ShareWeb';

export default function Profile() {
    const [tienda, setTienda] = useState({});

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda?.[0] || {});
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <div className='profile'>
            <div className='profile__header'>
                <div className='profile__avatar'>
                    {tienda.imagen1 ? (
                        <img src={tienda.imagen1} alt={tienda.nombre} />
                    ) : (
                        <span>{tienda.nombre?.charAt(0) || '?'}</span>
                    )}
                </div>
                <h2 className='profile__name'>{tienda.nombre || 'Sin nombre'}</h2>
                {tienda.eslogan && (
                    <p className='profile__eslogan'>{tienda.eslogan}</p>
                )}
            </div>

            <div className='profile__info'>
                {tienda.direccion && (
                    <Anchor
                        to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='profile__infoItem'
                    >
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <span>{tienda.direccion}</span>
                    </Anchor>
                )}
                {tienda.email && (
                    <Anchor to={`mailto:${tienda.email}`} className='profile__infoItem'>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>{tienda.email}</span>
                    </Anchor>
                )}
            </div>

            <div className='profile__socials'>
                {tienda.instagram && (
                    <Anchor to={tienda.instagram} target='_blank' rel='noopener noreferrer' className='profile__socialIcon profile__socialIcon--ig'>
                        <FontAwesomeIcon icon={faInstagram} />
                    </Anchor>
                )}
                {tienda.facebook && (
                    <Anchor to={tienda.facebook} target='_blank' rel='noopener noreferrer' className='profile__socialIcon profile__socialIcon--fb'>
                        <FontAwesomeIcon icon={faFacebook} />
                    </Anchor>
                )}
                {tienda.telefono && (
                    <Anchor to={`https://wa.me/${tienda.telefono}`} target='_blank' rel='noopener noreferrer' className='profile__socialIcon profile__socialIcon--wa'>
                        <FontAwesomeIcon icon={faWhatsapp} />
                    </Anchor>
                )}
            </div>

                <ShareWeb />
        </div>
    );
}